import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { IStudent } from '../../../../models/students/i-student';
import { ReportService } from '../../../../services/reports/report.service';
import { ActivatedRoute, Router } from '@angular/router';
import { JobTitleService } from '../../../../services/jobtitle/jobtitle.service';
import { JobTitle } from '../../../../models/jobtitle/jobtitle';
import { AddMedicalLetterComponent } from './components/add-medical-letter/add-medical-letter.component';
import { MedicalLetterEmployeeDatabase } from './medical-letter-employee-database';
import { MedicalLetterEmployeeDataSource } from './medical-letter-employee-data-source';
import { MedicalLetterService } from '../../../../services/medical-letter/medical-letter-service';
import { MedicalLetterTypeService } from '../../../../services/medical-letter-types/medical-letter-type.service';
import { Observable } from 'rxjs/Observable';
import { MedicalLetterDto } from '../../../../models/medical-letter/medical-letter-dto';
import { environment } from '../../../../../../environments/environment';
import { Location } from '@angular/common';
import { EmployeeService } from '../../../../services/employee/employee.service';

@Component({
    selector: 'fuse-medical-letter-employees',
    templateUrl: './medical-letter-employee.component.html',
    styleUrls: ['./medical-letter-employee.component.scss'],
    animations: fuseAnimations
})
export class MedicalLetterComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Name', 'RequestDate', 'RequestType', 'Observations', 'Actions'];
    medicalLetterEmployeeDatabase;
    dataSource: MedicalLetterEmployeeDataSource | null;
    confirmDialogRef: any;
    medicalLettersTypeSelected = -1;

    private sub: any;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    public employeeId = '';
    public medicalLettersTypes: any;
    public employee: any;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private medicalLetterService: MedicalLetterService,
        public jobTitleService: JobTitleService,
        private reportService: ReportService,
        private route: ActivatedRoute,
        private router: Router,
        public medicalLetterTypeService: MedicalLetterTypeService,
        private location: Location,
        private employeeService: EmployeeService,
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        this.sub = this.route.params.subscribe(params => {
            this.employeeId = params['id'] ? params['id'] : '';
            console.log('this.employeeId', this.employeeId);
        });


        Observable.combineLatest(
            this.medicalLetterTypeService.getAll(),
            this.employeeService.getByEmployeeId(this.employeeId)
        ).subscribe(([medicalLettersTypes, employee]) => {
            this.blockUI.stop();
            this.employee = employee;
            console.log('this.employee+++++', this.employee);
            this.medicalLettersTypes = medicalLettersTypes.slice();
            if (this.medicalLettersTypes.find(e => e.Id === -1) === undefined) {
                const todos = new JobTitle();
                todos.Id = -1;
                todos.Description = 'Todos';
                this.medicalLettersTypes.unshift(todos);
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });

        this.medicalLetterEmployeeDatabase = new MedicalLetterEmployeeDatabase(this.medicalLetterService, this.employeeId);
        this.dataSource = new MedicalLetterEmployeeDataSource(this.medicalLetterEmployeeDatabase, this.paginator, this.sort, this.medicalLettersTypeSelected);
        this.blockUI.stop();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    add() {
        const config: MatDialogConfig = {
            width: '90vw',
            maxWidth: '90vw',
            maxHeight: '80%',
            height: '80%',
            disableClose: true,
            data: {
                mode: 'new',
                employeeId: this.employeeId,
                employeeName: this.employee.LastName + " " + this.employee.FirstName,
                medicalLetter: new MedicalLetterDto(),
            }
        };

        this.confirmDialogRef = this.dialog.open(AddMedicalLetterComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.medicalLetterEmployeeDatabase.add(result);
            }
        });
    }

    editOrView(mode: string, medicalLetter: MedicalLetterDto) {
        console.log('medicalLetter>>>>>>', medicalLetter);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '90vw',
            maxWidth: '90vw',
            maxHeight: '80%',
            height: '80%',
            disableClose: true,
            data: {
                mode: mode,
                employeeId: this.employeeId,
                medicalLetter: Object.assign({}, medicalLetter),
            }
        };

        this.confirmDialogRef = this.dialog.open(AddMedicalLetterComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.medicalLetterEmployeeDatabase.edit(result);
            }
        });
    }

    delete(student: IStudent) {
        // this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', student.LastName + ' ' + student.FirstName, (res) => {
        //     this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
        //         this.medicalLetterService.delete(student.Id).subscribe(response => {
        //             if (response.resultCode === 1) {
        //                 this.employeetDatabase.delete(student);
        //                 const index = this.medicalLetterService.employees.findIndex(s => s.Id === student.Id);
        //                 if (index >= 0) {
        //                     this.medicalLetterService.employees.splice(index, 1);
        //                     delete this.medicalLetterService.employeesObject[student.Id];
        //                 }
        //                 this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
        //             } else {
        //                 this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res1: string) => {
        //                     this.sweetAlertService.error('Error', res1, null);
        //                 });
        //             }
        //         }, error => {
        //             this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res2: string) => {
        //                 this.sweetAlertService.error('Error', res2, null);
        //             });
        //         });
        //     }, () => {
        //         console.log('FuseStudentComponent > delete > canceled');
        //     });
        // });
    }

    print(medicalLetter: MedicalLetterDto) {
        window.open(environment.backendUri + 'report/MedicalLetter/' + medicalLetter.Id, '_new');
    }

    filterMedicalLetterByType(medicalLetterType: number) {
        this.dataSource.filterMedicalLetterByType(medicalLetterType);
        this.medicalLettersTypeSelected = medicalLetterType;
    }

    back(){
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/medical-letter/medical-letter-employee.component.ts